import { z } from "zod";

export const inquirySchema = z.object({
  authorName: z.string().min(2, "Name is required"),
  email: z.string().email("A valid email is required"),
  genre: z.string().min(1),
  manuscriptStatus: z.string().min(1),
  wordCount: z.coerce.number().int().positive().optional(),
  bookCount: z.coerce.number().int().positive().default(1),
  projectShape: z.enum(["series", "standalone", "catalog"]),
  editingStatus: z.string().min(1),
  coverStatus: z.string().min(1),
  isbnStatus: z.string().min(1),
  desiredServices: z.string().min(3),
  timeline: z.string().min(1),
  budgetRange: z.string().min(1),
  rightsConfirmed: z.literal(true),
  notes: z.string().max(3000).optional()
});

export type InquiryForm = z.infer<typeof inquirySchema>;
